import { useState } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import AboutUs from "./Pages/About";
import Header from "./Pages/Header";
import Navbar from "./Pages/Navbar";
import Footer from "./Pages/Footer";
import Courses from "./Pages/Course";
import ContactForm from "./Pages/Contact";
import Form from "./Pages/Form";
import UKUniversities from "./Pages/Uk";
import CanadaUniversities from "./Pages/Canada";
import AustraliaUniversities from "./Pages/Australia";
import ConsultantForm from "./Pages/ConsultantForm";
import Universities from "./Pages/Univarsities";
import ServicePage from "./Pages/Services";
import Consultentpage from "./Pages/Consultentpage";
import CountryPage from "./Pages/CountryPage";
import USUniversities from "./Pages/us";
import GermanyUniversities from "./Pages/germany";
import NewZealandUniversities from "./Pages/nz";
import Ireland from "./Pages/irland";
import SwitzerlandUniversities from "./Pages/Swizerland";
import DubaiUniversities from "./Pages/Dubai";
import SingaporeUniversities from "./Pages/Singapur";
import EuropeUniversities from "./Pages/EuropeUniversities";
import RussiaUniversities from "./Pages/Russia";
import AdminPage from "./Pages/AdminPages";
import SuccessStoryGrid from "./Pages/SuccessStory";

function AppContent() {
  const [showConsultant, setShowConsultant] = useState(true);
  const location = useLocation();

  const closeConsultant = () => {
    setShowConsultant(false);
  };
  const isAdminPage = location.pathname === "/admin-page-clyra";

  return (
    <>
      {!isAdminPage && showConsultant && <ConsultantForm onClose={closeConsultant} />}
      <Navbar />
      <Routes>
        <Route path="/" element={<Header />} />
        <Route path="/admin-page-clyra" element={<AdminPage />} />
        <Route path="/home" element={<Header />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/coaching" element={<Courses />} />
        <Route path="/contactus" element={<ContactForm />} />
        <Route path="/form" element={<Form />} />
        <Route path="/countries" element={<CountryPage />} />
        <Route path="/countries/uk" element={<UKUniversities />} />
        <Route path="/countries/Canada" element={<CanadaUniversities />} />
        <Route path="/countries/us" element={<USUniversities />} />
        <Route path="/countries/Australia" element={<AustraliaUniversities />} />
        <Route path="/countries/Germany" element={<GermanyUniversities />} />
        <Route path="/countries/newzeland" element={<NewZealandUniversities />} />
        <Route path="/countries/Ireland" element={<Ireland />} />
        <Route path="/universities" element={<Universities />} />
        <Route path="/successstories" element={<SuccessStoryGrid />} />
        <Route path="/services" element={<ServicePage />} />
        <Route path="/freecounselling" element={<Consultentpage />} />
        <Route path="/countries/switzerland" element={<SwitzerlandUniversities />} />
        <Route path="/countries/dubai" element={<DubaiUniversities />} />
        <Route path="/countries/singapore" element={<SingaporeUniversities />} />
        <Route path="/countries/europe" element={<EuropeUniversities />} />
        <Route path="/countries/russia" element={<RussiaUniversities />} />
      </Routes>
      <Footer />
    </>
  );
}

// Wrap your AppContent with Router
function AllRoutes() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default AllRoutes;
